const abortControllers = {
  typeahead: new AbortController(),
  communications: new AbortController(),
  asyncRender: new AbortController(),
}

/**
 * Centrally manage abort controllers. Provide a key to abort a class of requests and async actions.
 * @param key - The key of the abort controller to abort.
 * @param reason - The reason for aborting.
 */
export const abort = (
  key: keyof typeof abortControllers,
  reason: string = 'Aborted'
): void => {
  if (!abortControllers[key]) {
    return
  }

  abortControllers[key].abort(reason)
  abortControllers[key] = new AbortController()
}

/**
 * Get the signal of an abort controller for a specific class of requests and async actions.
 * @param key - The key of the abort controller to get the signal from.
 */
export const getSignal = (
  key: keyof typeof abortControllers
): AbortSignal | undefined => {
  if (!abortControllers[key]) {
    return
  }

  return abortControllers[key].signal
}
